module.exports = __webpack_public_path__ + "static/user6-bd69b599a702aae1f157d5a18317712e.jpg";